import React from "react";
import CommonLayout from "./CommonLayout";
import { useBlog } from "../../hooks/collections/useBlog";
import moment from "moment";
import ButtonSecondary from "../../shared/Button/ButtonSecondary";
import ButtonPrimary from "../../shared/Button/ButtonPrimary";
import { useUserSessionStore } from "../../stores/UserSession.store";
import { useFirebaseData } from "../../@shared/hooks/useFirebaseData";

export const AccountCompanyBlog = () => {
  const user = useUserSessionStore((state) => state.user);
  const { getReference } = useFirebaseData({ collectionPath: null, loadData: false });
  const { posts } = useBlog({
    loadData: true, queries: [
      { type: "where", field: "company", operator: "==", value: getReference(user.path)},
      { type: "orderBy", field: "createdAt", direction: "desc" }
    ]
  });

  return (
    <CommonLayout>
      <div className="space-y-6 sm:space-y-8">
        <div className="flex flex-col md:flex-row gap-5 items-center justify-between">
          <h2 className="text-3xl font-semibold">Blog</h2>
          <ButtonPrimary
            href={`/account-company-blog/new`}
          >New Post</ButtonPrimary>
        </div>

        <div>
          <table className={"w-full text-left min-w-[1000px] border-separate border-spacing-4"}>
            <thead>
            <tr>
              <th>Title</th>
              <th>Description</th>
              <th>Created At</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            {posts.map((post) => (
              <tr key={post.id}>
                <td>{post.title}</td>
                <td>{post.description}</td>
                <td className={"whitespace-nowrap"}>{moment(post.createdAt).format("YYYY-MM-DD")}</td>
                <td className={"flex gap-2 w-fit"}>
                  <ButtonSecondary href={`/account-company-blog/${post.id}`}>Edit</ButtonSecondary>
                  <ButtonSecondary href={`/blog/${post.id}`}>Open</ButtonSecondary>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    </CommonLayout>
  );
};
